
import { defineComponent } from 'vue';
import { AppFormRow, AppInput, AppSelect, AppCard, AppButton } from '@/components';
import { useAvatarDefaultTranslate } from '@/modules/avatar/default/model/translate';
import { ROUTE_NAME_AVATAR } from '@/modules/avatar/router';

export default defineComponent({
    name: ROUTE_NAME_AVATAR.DEFAULT.TRANSLATE,
    components: { AppFormRow, AppInput, AppSelect, AppCard, AppButton },
    setup() {
        const { model, v$, fetch, actions, systemLocaleSupported } = useAvatarDefaultTranslate();

        return { v$, model, fetch, actions, systemLocaleSupported };
    }
});
